function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.97596 0.240387C9.55829 0.240387 9.14063 0.66707 8.29327 1.51443L3.24519 6.58654C2.31671 7.51803 2.6262 7.69231 3.60577 7.69231H6.15385V13.8462C6.15385 15.1202 7.1875 16.1538 8.46154 16.1538H11.5385C12.8125 16.1538 13.8462 15.1202 13.8462 13.8462V7.69231H16.3462C17.4309 7.69231 17.6593 7.51803 16.7308 6.58654L11.6587 1.51443C10.8113 0.66707 10.3936 0.240387 9.97596 0.240387ZM0 14.6154V17.6923C0 18.9663 1.03365 20 2.30769 20H17.6923C18.9663 20 20 18.9663 20 17.6923V14.6154H18.4615V17.6923C18.4615 18.116 18.116 18.4615 17.6923 18.4615H2.30769C1.88401 18.4615 1.53846 18.116 1.53846 17.6923V14.6154H0Z"
});

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Upload.efc2dba7.svg";
export { ForwardRef as ReactComponent };